type EventTeam = {
  name_in_competition?: string;
  name_in_club?: string;
  logo?: string;
  score?: number;
  url?: string;
};

const getStringFromUnknown = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

const getNumberFromUnknown = (value: unknown): number | undefined =>
  typeof value === 'number' ? value : undefined;

export const getEventTeams = (value: unknown): EventTeam[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .filter(
      (item): item is Record<string, unknown> =>
        typeof item === 'object' && item !== null
    )
    .map((team) => ({
      name_in_competition: getStringFromUnknown(team.name_in_competition),
      name_in_club: getStringFromUnknown(team.name_in_club),
      logo: getStringFromUnknown(team.logo),
      score: getNumberFromUnknown(team.score),
      url: getStringFromUnknown(team.url),
    }));
};

export const getDateInput = (
  value: unknown
): string | number | Date | undefined => {
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }

  return value instanceof Date ? value : undefined;
};
